import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { RouterModule, Routes } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { NgxSpinnerModule } from "ngx-spinner";
import { CoreModule } from "src/app/core/core.module";
import { PipeModule } from "src/app/core/pipes/pipe.module";
import { AttachDeploymentComponent } from "./dialogs/attach-deployment/attach-deployment.component";
import { DetachDeploymentComponent } from "./dialogs/detach-deployment/detach-deployment.component";
import { UpdateJobSubmitIdComponent } from "./dialogs/update-job-submit-id/update-job-submit-id.component";
import { UserAccessControlComponent } from "./user-access-control.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ResizableModule } from "src/app/core/directive/resizable/resizable.module";

const routes: Routes = [
  { path: "", component: UserAccessControlComponent }
]

@NgModule({
  declarations: [
    UserAccessControlComponent,
    DetachDeploymentComponent,
    AttachDeploymentComponent,
    UpdateJobSubmitIdComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatTableModule,
    CoreModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    NgbTooltip,
    PipeModule,
    MatTooltipModule,
    MatCheckboxModule,
    ResizableModule
  ],
  exports: [
    RouterModule,
    UserAccessControlComponent,
    DetachDeploymentComponent,
    AttachDeploymentComponent,
    UpdateJobSubmitIdComponent,
  ]
})
export class UserAccessControlModule { };
